import { render, staticRenderFns } from "./EgresoCategoriaUpdate.vue?vue&type=template&id=364c86f1&scoped=true&"
import script from "./EgresoCategoriaUpdate.vue?vue&type=script&lang=js&"
export * from "./EgresoCategoriaUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364c86f1",
  null
  
)

export default component.exports